import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpMainBreadcrumbComponent from './adpMainBreadcrumb.component';

let adpMainBreadcrumbModule = angular.module('adpMainBreadcrumb', [
  uiRouter
])

.component('adpMainBreadcrumb', adpMainBreadcrumbComponent)

.name;

export default adpMainBreadcrumbModule;



// WEBPACK FOOTER //
// ./src/app/components/adpMainBreadcrumb/adpMainBreadcrumb.js